import React from "react";
import { FormGroup, Label } from "reactstrap";
import PropTypes from "prop-types";

const FormDropdown = ({
  name,
  options,
  onChange,
  className,
  value,
  errors,
  children,
  label,
  refValue,
  defaultValue,
  isRequired,
  onChangeHandler,
  readonly,
  placeholder = "",
  showDefaultOption = true,
  disabled,
  showLabel = true,
  removeOptions = false,
  removedOptionsIdArr = [],
  ...props
}) => {
  return (
    <FormGroup>
      {showLabel && (
        <Label className="form-label" htmlFor="fv-topics">
          {label}
          <span style={{ color: "#f3245f" }}> {isRequired && "*"}</span>
        </Label>
      )}

      <div className="form-control-wrap">
        <div className="form-control-select">
          <select
            ref={refValue}
            className={className}
            id={name}
            name={name}
            defaultValue={defaultValue}
            onChange={onChangeHandler}
            readOnly={readonly && "readOnly"}
            disabled={disabled}
            //placeholder={placeholder}
          >
            {showDefaultOption ? <option label={`${placeholder}`} value=""></option> : ""}
            {options.map((item) => {
              let selectOption = false;
              if (item.value == defaultValue) {
                selectOption = true;
              }
              if (removeOptions === true) {
                if (!removedOptionsIdArr.includes(Number(item.value))) {
                  return (
                    <option selected={selectOption ? "selected" : ""} key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  );
                }
              } else {
                return (
                  <option selected={selectOption ? "selected" : ""} key={item.value} value={item.value}>
                    {item.label}
                  </option>
                );
              }
            })}
          </select>
          {errors && <span className="invalid">This field is required</span>}
        </div>
      </div>
    </FormGroup>
  );
};

FormDropdown.defaultProps = {
  className: "form-control form-select",
};

FormDropdown.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  className: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default FormDropdown;
